import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';

@Component({
  selector: 'clients-dialog',
  templateUrl: 'clients.dialog.html',
  styleUrls: ['clients.dialog.css'],
})

export class ClientsDialogComponent implements OnDestroy {
  addAdminForm: FormGroup;

  public type = '';

  controllers = [];
  passwordReset = false;
  resetInProgress = false;
  timerSub = null;
  error = '';
  saveInProgress = false;

  constructor(public dialogRef: MatDialogRef<ClientsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpClient, private auth: AuthenticationService, private urlHelper: UrlHelper) {

    this.addAdminForm = new FormGroup({
      company_name: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      phone: new FormControl('', Validators.required),
      active: new FormControl(1, Validators.required),
      is_premium: new FormControl(0, Validators.required),
      controllers: new FormControl(''),
    });

    if (data.user) {
      if (data.user.hasOwnProperty('relationships') && data.user.relationships.hasOwnProperty('parks')
        && data.user.relationships.parks.hasOwnProperty('data') && data.user.relationships.parks.data) {

        data.user.relationships.parks.data.forEach(park => {
          data.included.forEach(inc => {
            if (inc.type === 'Parks' && inc.id === park.id) {
              this.controllers.push(inc);
            }
          });
        });
      }

      this.addAdminForm.patchValue({
        company_name: data.user.attributes.company_name,
        email: data.user.attributes.email,
        phone: data.user.attributes.phone,
        active: data.user.attributes.active,
        is_premium: data.user.attributes.is_premium && 1 || 0,
        controllers: data.user.relationships.parks.data.map(c => c.id),
      });
      this.addAdminForm.get('email').disable();
    }

    if ('admin' !== this.auth.userRole()) {
      this.addAdminForm.get('is_premium').disable();
    }

    this.retrieveUnassignedControllers(1).subscribe((res: any) => {
      this.controllers = this.controllers.concat(res);
    });
  }

  private prepareUrl(nextPage) {
    if ('manufacturer' === this.auth.userRole()) {
      return `/manufacturers/${this.auth.userId()}/parks?page=${nextPage}`;
    }

    return `/parks?page=${nextPage}`;
  }

  retrieveUnassignedControllers(page) {
    return this.http.get(this.prepareUrl(page)).expand((prev: any) => {
      if (typeof prev.meta === 'undefined' || prev.meta.pagination.current_page >= prev.meta.pagination.last_page) {
        return Observable.empty();
      }

      const nextPage = prev.meta.pagination.current_page + 1;

      return this.http.get(this.prepareUrl(nextPage));
    }).scan((acc, r) => acc.concat(r.data), []).last();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onCloseConfirm() {
    this.dialogRef.close('Confirm');
  }

  onCloseCancel() {
    this.dialogRef.close('Cancel');
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }

  onSubmit({value, valid}) {
    if (valid) {
      this.saveInProgress = true;

      this.save(value).subscribe((res) => {
        this.saveInProgress = false;
        this.onCloseConfirm();
      }, (err) => {
        this.saveInProgress = false;

        if (err.hasOwnProperty('error') && err.error.hasOwnProperty('errors') && Array.isArray(err.error.errors)) {
          this.error = err.error.errors[0].detail;
        } else {
          this.error = 'An error occurred';
        }
        // do nothing
      }, () => {
        this.saveInProgress = false;
      });
    }
  }

  resetPassword() {
    this.resetInProgress = true;

    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.auth.forgotPassword(this.data.user.attributes.email).subscribe((res) => {
      this.passwordReset = true;
      this.resetInProgress = false;

      this.timerSub = Observable.of(true).delay(5000).subscribe(() => {
        this.passwordReset = false;
      });
    });
  }

  private save(data): Observable<any> {
    const controllers = [];

    if (data.controllers && data.controllers.length > 0) {
      data.controllers.forEach(controllerId => {
        controllers.push({type: 'Controllers', id: controllerId});
      });
    }

    const body = {
      data: {
        type: 'Clients',
        attributes: {
          company_name: data.company_name,
          phone: data.phone,
          active: data.active === 1,
          is_pro: true,
          is_premium: data.is_premium === 1,
        },
        relationships: {
          controllers: {
            data: controllers
          }
        }
      }
    };

    if (this.data.user) {
      body.data['id'] = this.data.user.id;
      return this.http.put(this.prepareUrl2(true), body);
    } else {
      body.data.attributes['email'] = data.email;
      return this.http.post(this.prepareUrl2(false), body);
    }
  }

  private prepareUrl2(edit) {
    if ('manufacturer' === this.auth.userRole()) {
      if (edit) {
        return `/manufacturers/${this.auth.userId()}/clients/${this.data.user.id}`;
      } else {
        return `/manufacturers/${this.auth.userId()}/clients`;
      }
    } else {
      if (edit) {
        return `/clients/${this.data.user.id}`;
      } else {
        return `/clients`;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/clients/clients.dialog.component.ts